/* eslint-disable no-console */

/**
 * A generic error handler that throws the error. This is a useful default error
 * handler for promises that almost always resolve correctly, but we want to
 * be triple-sure are handled properly. If we don't do this, we get unhandled
 * promise rejection errors that can cause awkward behavior.
 *
 * This is mostly useful for the frontend, as per the name, since backend promises
 * are more often `await`ed (e.g., handled correctly!).
 */
export function handleFrontendError(error: unknown) {
  if (error instanceof Error) {
    // Why not `console.error`? Because in some situations, browsers don't always
    // log a full Error object's message and stack trace.
    console.error(error.message, error.stack);
  } else {
    console.error(error);
  }
}
